export default __webpack_public_path__ + "static/char-s-57-zh-Hant-6f1e5a3b99b8d59a1b4f8d68cf603ad0.png";